import "app/wdyr"; // <--- first import

import "@babel/polyfill";

import React from "react";
import * as ReactDOM from "react-dom";
//import { Helmet, HelmetProvider } from 'react-helmet-async';

import { AppContainer } from "react-hot-loader";
import { Provider } from "react-redux";
//import { ConnectedRouter } from 'react-router-redux';
import { ConnectedRouter } from "connected-react-router";
import configureStore from "./configureStore";
import { IApplicationState } from "./store";
import * as RoutesModule from "./routes";
let routes = RoutesModule.Routes;
import { Routes } from "./routes";
import { createBrowserHistory, Location } from "history";

import Loadable from "react-loadable";

import { SEOHelmet } from "components/SEO/SEOHelmet";

// Import Google Analytics and Tag Manager so that we can track how users use the website
import * as ReactGA from "react-ga";
import TagManager from "react-gtm-module";

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href")!;
export const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const preloadedState = (window as any).initialReduxState as IApplicationState;
const store = configureStore(history, preloadedState);

// Get host of the website so we can differentiate between the live, test and development sites for analytics and so on
const hostname = window && window.location && window.location.hostname;

if (hostname === "www.qorestudio.com" || hostname === "qorestudio.com") {
  //console.log('------------------------------------------------------------------------------------ LIVE SITE')

  // ---------------------------------------------------------------------- Google Analytics Setup
  ReactGA.initialize("UA-58133466-1");
  ReactGA.pageview(window.location.pathname + window.location.search);

  // ---------------------------------------------------------------------- Google Tag Manager Setup

  const tagManagerArgs = {
    gtmId: "GTM-PN7FTKW",
  };

  TagManager.initialize(tagManagerArgs);

  // ---------------------------------------------------------------------- Update Google Analytics location when react router changes location

  history.listen((location, action) => {
    ReactGA.set({ page: location.pathname });
    ReactGA.pageview(location.pathname);
  });
} else if (hostname === "test.qorestudio.com") {
  //console.log('------------------------------------------------------------------------------------ TEST SITE')
} else {
  //console.log('------------------------------------------------------------------------------------ DEV SITE');
  //console.log('------------------------------------------------------------------------------------ React Version: ' + React.version);
}

const isDevBuild = process.env.NODE_ENV === "development";
if (isDevBuild) {
  console.log("Looks like we are in development mode!");
}

function renderApp() {
  const app = (
    <AppContainer>
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <Routes />
        </ConnectedRouter>
      </Provider>
    </AppContainer>
  );

  // This code sets up the lazy loading of react modules and code split components ready for rehydration from SSR
  Loadable.preloadReady().then(() => {
    // This code starts up the React app when it runs in a browser. It sets up the routing configuration
    // and injects the app into a DOM element.
    ReactDOM.hydrate(app, document.getElementById("react-app"));
  });
}

renderApp();

// Allow Hot Module Replacement
if (module.hot) {
  module.hot.accept("./routes", () => {
    routes = require<any>("./routes").RoutesComponent;
    //routes = require<typeof RoutesModule>('./routes').RoutesComponent;
    renderApp();
  });
}
